/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Page_SubtitleInputs */

const vi_packaging_page_subtitle = /** @type {(inputs: Packaging_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý vật tư bao bì (hộp, túi, tem...) và định mức tiêu hao theo sản phẩm.`)
};

/**

* @param {Packaging_Page_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_page_subtitle = /** @type {((inputs?: Packaging_Page_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Page_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_page_subtitle(inputs)
});